const map = {
	"./basic-tier-status-card-cn.png": 61,
	"./basic-tier-status-card.png": 151,
	"./laptop-premium-display.png": 55,
	"./premium-plus-status-card-cn.png": 144,
	"./premium-plus-status-card.png": 384,
	"./premium-status-card-cn.png": 595,
	"./premium-status-card.png": 353
};


function webpackContext(req) {
	const id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		const e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 760;